import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';


@Component({
    selector: 'app-dashboard',
    templateUrl: './pricegroup.component.html',
    // styleUrls: ['./dashboard.component.scss']
 providers: [ SharedService,PopupSegmentComponent]
})
export class PriceGroupComponent implements OnInit {

itemsTotalAdv : number =0;
country = '';
countryCode : number =0;
 objLoaderStatus: boolean = false;
 id : number;
 dataGender : any =[];
  dataAge : any =[];
 editFlagAge = [];
  editFlagGender = [];
 page : number =1;
  errormessage = "";
  message ="";
    editFlagGenderUpdate = [];
 editFlagAgeUpdate = [];

    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService, private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) {
    

    
    }

     ngOnInit() {
       var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

    var token = this.localstorage.getStorage("token");
                  this.loaderService.displayLoader(true);

 this.shareService.CallDatawithToken("admin/getAllPriceGroupedUser", null, token).subscribe((result) => {
        if(result.data){
        var data = result.data;
        console.log(data);
        var i=0;
        for(i=0;i<data.length;i++){
        if(data[i].type == "GENDER"){
          this.dataGender.push(data[i]);
        }
        else{
          this.dataAge.push(data[i]);
        }
        }
        console.log(this.dataAge);
        console.log(this.dataGender);
       // this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
                      this.loaderService.displayLoader(false);

        }
      });


    }



   changeFlag(id,type){
  this.id = id;
  var i=0;
  if(type == "GENDER"){
  for(i=0;i<this.dataGender.length;i++){
    this.editFlagGender[this.dataGender[i].id] = false;
    console.log(this.dataGender[i].id);
    console.log(id);
if(this.dataGender[i].id == id){
this.editFlagGender[id] = true;
}
}
  }
  else{
    for(i=0;i<this.dataAge.length;i++){
    this.editFlagAge[this.dataAge[i].id] = false;
    console.log(this.dataAge[i].id == id);
if(this.dataAge[i].id == id){
this.editFlagAge[id] = true;
}
  }
}
   }



editPrice(id,price,type,name){
        var token = this.localstorage.getStorage("token");
        var data : any = {};
        data.id = id;
        data.price = parseInt(price);
        data.name = name;
        data.type = type;
        this.errormessage = "";
        if( price.toString().trim() != ''){
    this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/updatePriceGroupedUser",data,token).subscribe((result) => {
    console.log(result.data);
    if(result.data && result.data.status == true){
         this.message = "Price updated successfully";
         this.showUpdate();
         if(type == "GENDER"){
       this.editFlagGender[id] = false;
         }
         else{
           this.editFlagAge[id] = false;
         }
    this.loaderService.displayLoader(false);
    }
    else{
          this.loaderService.displayLoader(false);

       this.message =result.meta.message;
        this.showUpdate();
    }
    this.loaderService.displayLoader(false);
});
 }
        else{
          this.errormessage = "Price can not be empty";
          console.log("isndie else");
          if(type == "GENDER"){
       this.editFlagGenderUpdate[id] = true;
         }
         else{
           this.editFlagAgeUpdate[id] = true;
         }
        }
}

 downloadPrice(){
        var token = this.localstorage.getStorage("token");

window.location.href = this.shareService.apiUrl+"master/getCsvPriceGroup?token="+token;


    }
 showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Price Group Information', 
                message:this.message,
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                 
                });
        }

        
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/pricingdetails/pricegroup.component.ts